<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import {onMount, createEventDispatcher} from 'svelte';
    import MediaLibrary from '../../common/Media/MediaLibrary.svelte';
    import ElementMediaThumbnail from './ElementMediaThumbnail.svelte';
    import {get, submit} from '../../../utils.js';
    import {selectedMedia, targetItem, elementVersionEntity} from './elementMediaStore.js';

    export let id = 'elementMediaLibrary';
    export let title = sgettext('$$ELEMENT_MEDIA_LIBRARY$$');
    export let elementId = 0;
    export let uploadApi = '';

    const dispatch = createEventDispatcher();
    let mediaSourceApi = `${PATH_PREFIX}/sw/api/elements_database/elements/{0}/element_media/`;
    let mediaViewSetApi = `${PATH_PREFIX}/sw/api/elements_database/elementmedia/`;
    let list = [];


    $: if(elementId) {
        getAllMedia();
    }

    async function getAllMedia(){
        const resp = await get(mediaSourceApi.replace('{0}', elementId));
        if(resp.ok){
            list = await resp.json();
        }
    }

    async function handleMediaDelete(id){
        return await submit(`${mediaViewSetApi}${id}/destroy_with_kwargs/`, 'POST', {element_id: elementId});
    }

    function handleThumbnailClick(id){
        const selected = list.filter(l => l.id === id);

        if(selected.length){
            selectedMedia.set(selected[0]);
            dispatch('selected', {
                media: $selectedMedia,
                target: $targetItem,
                entity: $elementVersionEntity
            });
        }
    }


</script>


<MediaLibrary
    {id}
    {title}
    bind:list
    {uploadApi}
    thumbnailComponent={ElementMediaThumbnail}
    handleDelete={handleMediaDelete}
    {handleThumbnailClick}
 />
